<template>
  <div class="usersExampleUser">
    <Row type="flex" justify="space-around">
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 1"
        >
          <use xlink:href="#icon-mpai-people_6"></use>
        </svg>
        <div :class="index === 1 ? 'fontStyle' : ''" @click="index = 1">
          初级
        </div>
        <div :class="index === 1 ? 'fontStyle' : ''" @click="index = 1">
          数据分析师
        </div>
      </i-col>
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 2"
        >
          <use xlink:href="#icon-mpai-people_4"></use>
        </svg>
        <div :class="index === 2 ? 'fontStyle' : ''" @click="index = 2">
          高级
        </div>
        <div :class="index === 2 ? 'fontStyle' : ''" @click="index = 2">
          数据分析师
        </div>
      </i-col>
    </Row>
    <div v-if="index === 1" class="pinchedContent">
      <row class="pinchedContext" type="flex">
        <i-col class="pinched" span="12">
          <p>
            作为一个刚入职的数据分析师，虽然我对很多模型很了解，基础也比较好，但是积攒的数据分析模板比较少，平时有时候工作太忙了也忘记积累模板，平时遇到一个没学过的模型，也是需要耗费较多的时间去翻译文献学习，
            这些对工作效率都是蛮影响的，如果能有一个软件能帮我解决这些问题就好了。
          </p>
        </i-col>
        <i-col span="12"></i-col>
      </row>
    </div>
    <div v-else-if="index === 2" class="pinchedContent">
      <row class="pinchedContext" type="flex">
        <i-col span="12"></i-col>
        <i-col class="pinched" span="12">
          <p>
            把市面上所有的数据科学软件都下载下来了，统计功能的SPSS,
            机器学习的SPSS modeler, 文本挖掘的SPSS Text Analysis,
            计量经济学的eviews, 绘制的统计图形的stata,
            启动慢也就算了，数据量稍微高些时还常常卡机。数据量一大，只能用python,matlab两种编程语言来实现。学习这些花费了很多学习成本，在做一个数据分析项目报告时，同时这么多软件工具各种切换，有时候操作步骤忘了还得回去重新看书学习。哎，太难了！要是有个高效率，操作简单，同时一站式整合功能的软件就好了。
          </p>
        </i-col>
      </row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 1
    };
  }
};
</script>

<style lang="less" scoped>
.fontStyle {
  color: #2d8cf0;
}
.pinched {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinched:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinched:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinched > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.usersExampleUser {
  padding: 10px 0;
  width: 100%;
  .users_plane {
    height: 130px;
    text-align: center;
    cursor: pointer;
    .users_plane_img {
      height: 80px;
      width: 100%;
    }
  }
}
.pinchedContent {
  display: flex;
  justify-content: center;
}
.pinchedContext {
  padding: 0 5px;
  max-width: 1500px;
}
.pinchedRight {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedRight:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 86.5%;
  height: 20px;
  background: #ffff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedRight:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 86.5%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedRight > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 13.5%;
  height: 20px;
  background: #ffff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinchedleft {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedleft:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 23%;
  height: 20px;
  background: #ffff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedleft:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 23%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedleft > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 77%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinched {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinched:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinched:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinched > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
</style>
